import { useEffect, Fragment } from "react";
import { pastVisits } from "../../apiHandler/actions/profile";
import { displayDateFormatter, DataGridCustomPagination } from "../helpers";
import placeholder from "../../assets/placeholder.png";
import { Skeleton } from "@material-ui/lab";
import { DataGrid } from "@mui/x-data-grid";

const columns = [
  {
    field: "providerFirstName",
    headerName: "Provider",
    renderCell: (e) => {
      return (
        <Fragment>
          <img
            src={placeholder}
            width={25}
            height={25}
            alt=""
            style={{ marginRight: "10px" }}
          />
          {e.row.providerFirstName} {e.row.providerLastName}
        </Fragment>
      );
    },
    flex: 1,
  },
  { field: "appntDate", headerName: "DATE", flex: 1 },
  { field: "reason", headerName: "Reason", flex: 1 },
];

const Component = (props) => {
  const { pastVisitRecords, setPastVisitRecords, uuid } = props;

  useEffect(() => {
    fetchPastVisits();
    // eslint-disable-next-line
  }, []);

  const fetchPastVisits = async () => {
    const response = await pastVisits(uuid);
    setPastVisitRecords(
      response.map((r) => {
        return {
          ...r,
          id: r.appointmentId,
          appntDate: displayDateFormatter(r.appntDate),
        };
      })
    );
  };

  return (
    <div className="profile-table">
      {pastVisitRecords === null ? (
        <div className="profile-skeleton-cont">
          <Skeleton variant="text" height={40} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
        </div>
      ) : (
        <DataGrid
          rows={pastVisitRecords}
          columns={columns}
          autoHeight="true"
          pagination
          disableExtendRowFullWidth={true}
          pageSize={5}
          slots={{
            pagination: DataGridCustomPagination,
          }}
          disableRowSelectionOnClick
        />
      )}
    </div>
  );
};

export default Component;
